export default __webpack_public_path__ + "static/media/JrC.41e15740.png";